import { useAppContext } from "../../../AppContext";

export const usePermissions = () => {
  const { privateRoutes: routes, currentUser } = useAppContext();

  const userHavePermissionsByRoute = (route?: string): boolean => {
    if (!currentUser?.permissions) {
      return false;
    }

    // the resource is open to everyone
    if (!route) {
      return true;
    }

    const currentRoute = routes.find((x) => route.includes(x.path));

    if (!currentRoute) {
      return false;
    }

    return !!currentRoute.authenticationEndpoint
      ? userHavePermissions(currentRoute.authenticationEndpoint)
      : true;
  };

  const userHavePermissions = (endpoint?: string): boolean => {
    if (!currentUser?.permissions || !endpoint) {
      return false;
    }

    const normalizedEndpoint = endpoint.toLowerCase();

    return currentUser.permissions.some((permission) =>
      normalizedEndpoint.includes(permission.toLowerCase())
    );
  };

  return { userHavePermissions, userHavePermissionsByRoute };
};
